import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";
import { VamTitularEntity } from "../../../vam/titulares/entities/vam_titulares_entity";

@Pipe({
    name: "dataFilterTitularesExclusionCedula"
})
export class DataFilterPipeExclusionCedula implements PipeTransform {

    transform(array: VamTitularEntity[], query: string): any {
        if (query) {
            return _.filter(array, row => ((row.Cedula + "").toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}
@Pipe({
    name: "dataFilterTitularesExclusionNombre"
})
export class DataFilterPipeExclusionNombre implements PipeTransform {

    transform(array: VamTitularEntity[], query: string): any {
        if (query) {
            return _.filter(array, row => ((row.PrimerNombre + " " + row.SegundoNombre + " " + row.ApellidoPaterno + "" + row.ApellidoMaterno).toUpperCase()).indexOf((query.toUpperCase())) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitud-exclusion.filter.ts